import React, { ReactElement } from "react";

/**
 * Inline footer glyphs for the 2026 refresh footer. All use `currentColor`
 * so the colour is driven by the surrounding CSS (redesign brand tokens),
 * never a hardcoded hex.
 */

type IconProps = { className?: string };

export const FacebookIcon = ({ className }: IconProps): ReactElement => (
  <svg
    viewBox="0 0 28 27.897"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M14 0C6.268 0 0 6.268 0 14C0 20.566 4.52 26.075 10.618 27.588V18.278H7.731V14H10.618V12.157C10.618 7.392 12.774 5.183 17.453 5.183C18.34 5.183 19.87 5.357 20.496 5.531V9.409C20.166 9.374 19.592 9.357 18.879 9.357C16.583 9.357 15.696 10.227 15.696 12.487V14H20.269L19.483 18.278H15.696V27.897C22.628 27.06 28 21.157 28 14C28 6.268 21.732 0 14 0Z"
      fill="currentColor"
    />
  </svg>
);

export const InstagramIcon = ({ className }: IconProps): ReactElement => (
  <svg
    viewBox="0 0 27.9995 28.001"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.20163 0.0994665C6.71163 0.169467 5.69463 0.407467 4.80563 0.756467C3.88563 1.11547 3.10563 1.59647 2.32863 2.37547C1.55263 3.15447 1.07463 3.93547 0.718628 4.85647C0.373628 5.74747 0.140628 6.76547 0.0746278 8.25647C0.00862783 9.74647 -0.00537212 10.2265 0.00162788 14.0275C0.00862788 17.8285 0.0256278 18.3055 0.0976278 19.7995C0.168628 21.2885 0.405628 22.3055 0.754628 23.1955C1.11363 24.1155 1.59463 24.8955 2.37363 25.6725C3.15263 26.4485 3.93263 26.9255 4.85663 27.2825C5.74663 27.6265 6.76563 27.8615 8.25563 27.9265C9.74563 27.9915 10.2256 28.0065 14.0266 27.9995C17.8276 27.9925 18.3056 27.9755 19.7996 27.9045C21.2936 27.8335 22.3046 27.5955 23.1946 27.2475C24.1146 26.8875 24.8956 26.4075 25.6716 25.6275C26.4476 24.8475 26.9256 24.0665 27.2806 23.1445C27.6256 22.2545 27.8596 21.2355 27.9246 19.7465C27.9896 18.2525 28.0056 17.7755 27.9976 13.9735C27.9896 10.1715 27.9736 9.69547 27.9026 8.20247C27.8316 6.70947 27.5946 5.69547 27.2456 4.80547C26.8856 3.88547 26.4056 3.10547 25.6266 2.32847C24.8476 1.55147 24.0656 1.07447 23.1436 0.719466C22.2526 0.374466 21.2346 0.139466 19.7446 0.0754664C18.2546 0.0114664 17.7746 -0.0055335 13.9726 0.0014665C10.1706 0.0084665 9.69463 0.0254665 8.20163 0.0974665M8.36563 25.4065C7.00063 25.3475 6.25963 25.1205 5.76563 24.9305C5.11163 24.6785 4.64563 24.3735 4.15363 23.8865C3.66163 23.3995 3.35863 22.9315 3.10363 22.2785C2.91163 21.7845 2.68063 21.0445 2.61663 19.6795C2.54763 18.2045 2.53263 17.7615 2.52463 14.0235C2.51663 10.2855 2.53063 9.84347 2.59563 8.36747C2.65363 7.00347 2.88163 6.26147 3.07163 5.76747C3.32363 5.11247 3.62763 4.64747 4.11563 4.15547C4.60363 3.66347 5.07063 3.36047 5.72363 3.10547C6.21663 2.91247 6.95763 2.68347 8.32163 2.61847C9.79763 2.54847 10.2406 2.53447 13.9776 2.52647C17.7146 2.51847 18.1586 2.53247 19.6356 2.59747C20.9996 2.65647 21.7416 2.88247 22.2346 3.07347C22.8886 3.32547 23.3546 3.62847 23.8466 4.11747C24.3386 4.60647 24.6416 5.07147 24.8976 5.72647C25.0906 6.21847 25.3196 6.95847 25.3836 8.32347C25.4536 9.79947 25.4696 10.2425 25.4766 13.9795C25.4836 17.7165 25.4706 18.1605 25.4056 19.6355C25.3456 21.0005 25.1196 21.7415 24.9296 22.2365C24.6776 22.8905 24.3736 23.3565 23.8846 23.8485C23.3956 24.3405 22.9296 24.6435 22.2766 24.8985C21.7836 25.0905 21.0426 25.3205 19.6796 25.3855C18.2036 25.4545 17.7606 25.4695 14.0226 25.4775C10.2846 25.4855 9.84163 25.4705 8.36563 25.4065ZM19.7786 6.51847C19.7806 7.44647 20.5336 8.19747 21.4616 8.19547C22.3896 8.19347 23.1406 7.44047 23.1386 6.51247C23.1366 5.58447 22.3836 4.83347 21.4556 4.83547C20.5276 4.83747 19.7776 5.59047 19.7786 6.51847ZM6.81163 14.0145C6.81963 17.9845 10.0436 21.1965 14.0136 21.1885C17.9836 21.1805 21.1966 17.9565 21.1896 13.9865C21.1816 10.0165 17.9566 6.80347 13.9866 6.81147C10.0166 6.81947 6.80363 10.0445 6.81163 14.0145ZM9.33463 14.0095C9.32963 11.4325 11.4146 9.33847 13.9926 9.33347C16.5696 9.32847 18.6636 11.4135 18.6686 13.9915C18.6736 16.5685 16.5886 18.6625 14.0106 18.6675C11.4336 18.6725 9.33963 16.5885 9.33463 14.0115"
      fill="currentColor"
    />
  </svg>
);

export const LinkedinIcon = ({ className }: IconProps): ReactElement => (
  <svg
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.111 0H2.889C1.294 0 0 1.293 0 2.889V23.111C0 24.706 1.293 26 2.889 26H23.111C24.706 26 26 24.707 26 23.111V2.889C26 1.294 24.707 0 23.111 0ZM7.861 22.389H3.984V9.87H7.861V22.389ZM5.904 8.231C4.637 8.231 3.611 7.197 3.611 5.921C3.611 4.645 4.637 3.611 5.904 3.611C7.171 3.611 8.196 4.645 8.196 5.921C8.196 7.197 7.17 8.231 5.904 8.231ZM22.389 22.389H18.531V15.818C18.531 14.016 17.846 13.009 16.42 13.009C14.869 13.009 14.058 14.057 14.058 15.818V22.389H10.34V9.87H14.058V11.556C14.058 11.556 15.176 9.487 17.833 9.487C20.49 9.487 22.389 11.108 22.389 14.462V22.389Z"
      fill="currentColor"
    />
  </svg>
);

export const YoutubeIcon = ({ className }: IconProps): ReactElement => (
  <svg
    viewBox="0 0 32 22.545"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M31.331 3.521C30.963 2.135 29.879 1.044 28.502 0.673C26.006 0 16 0 16 0C16 0 5.993 0 3.498 0.673C2.121 1.043 1.037 2.135 0.669 3.521C0 6.033 0 11.273 0 11.273C0 11.273 0 16.514 0.669 19.025C1.037 20.411 2.121 21.502 3.498 21.872C5.994 22.545 16 22.545 16 22.545C16 22.545 26.007 22.545 28.502 21.872C29.879 21.502 30.963 20.41 31.331 19.025C32 16.513 32 11.273 32 11.273C32 11.273 32 6.033 31.331 3.521ZM12.727 16.031V6.515L21.091 11.273L12.727 16.031Z"
      fill="currentColor"
    />
  </svg>
);

export const AppStoreIcon = ({ className }: IconProps): ReactElement => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M8.17083 4.05161C8.79948 4.05161 9.5875 3.60405 10.0568 3.00732C10.4818 2.46653 10.7917 1.71128 10.7917 0.956036C10.7917 0.853472 10.7828 0.750908 10.7651 0.666992C10.0656 0.694964 9.22448 1.16116 8.71979 1.78587C8.32135 2.2614 7.95833 3.00732 7.95833 3.77189C7.95833 3.88378 7.97604 3.99566 7.9849 4.03296C8.02917 4.04228 8.1 4.05161 8.17083 4.05161ZM5.95729 15.3337C6.81615 15.3337 7.19688 14.7276 8.26823 14.7276C9.35729 14.7276 9.59635 15.315 10.5526 15.315C11.4911 15.315 12.1198 14.4013 12.713 13.5062C13.3771 12.4805 13.6516 11.4735 13.6693 11.4269C13.6073 11.4083 11.8099 10.6344 11.8099 8.46186C11.8099 6.57841 13.2266 5.72993 13.3063 5.66466C12.3677 4.24741 10.9422 4.21012 10.5526 4.21012C9.49896 4.21012 8.6401 4.88144 8.1 4.88144C7.51563 4.88144 6.74531 4.24741 5.83333 4.24741C4.09792 4.24741 2.33594 5.7579 2.33594 8.61105C2.33594 10.3826 2.99115 12.2567 3.79688 13.4689C4.4875 14.4945 5.08958 15.3337 5.95729 15.3337Z"
      fill="currentColor"
    />
  </svg>
);

export const PlayStoreIcon = ({ className }: IconProps): ReactElement => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g clipPath="url(#footer-playstore)">
      <path
        d="M10.1897 4.74263L3.10202 0.607318C2.18929 -0.00074105 1.02034 0.428851 0.632812 1.34285L7.1124 7.82116L10.1909 4.74263H10.1897Z"
        fill="currentColor"
      />
      <path
        d="M13.8829 6.89563L10.7687 5.0791L7.57031 8.27619L10.7814 11.4873L13.8829 9.6797C14.8772 9.0181 14.8772 7.55723 13.8829 6.89435V6.89563Z"
        fill="currentColor"
      />
      <path
        d="M0.546875 15.2966C0.929302 16.217 2.10335 16.6517 3.0199 16.041L10.1203 11.9045L7.03029 8.81445L0.546875 15.2966Z"
        fill="currentColor"
      />
      <path
        d="M0.5 2.12207V14.4311L6.6558 8.27659L0.5 2.12207Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="footer-playstore">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
